import React from "react";

const AddUser = () => {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7625 7.11252H16.15V4.31832C16.15 4.17861 16.0431 4.0643 15.9125 4.0643H15.4375C15.3069 4.0643 15.2 4.17861 15.2 4.31832V7.11252H12.5875C12.4569 7.11252 12.35 7.22683 12.35 7.36654V7.87458C12.35 8.01429 12.4569 8.1286 12.5875 8.1286H15.2V10.9228C15.2 11.0625 15.3069 11.1768 15.4375 11.1768H15.9125C16.0431 11.1768 16.15 11.0625 16.15 10.9228V8.1286H18.7625C18.8931 8.1286 19 8.01429 19 7.87458V7.36654C19 7.22683 18.8931 7.11252 18.7625 7.11252ZM9.31 9.14467C8.45797 9.14467 8.04828 9.65271 6.65 9.65271C5.25172 9.65271 4.845 9.14467 3.99 9.14467C1.78719 9.14467 0 11.0562 0 13.4122V14.7331C0 15.5745 0.638281 16.2572 1.425 16.2572H11.875C12.6617 16.2572 13.3 15.5745 13.3 14.7331V13.4122C13.3 11.0562 11.5128 9.14467 9.31 9.14467ZM12.35 14.7331C12.35 15.0125 12.1362 15.2411 11.875 15.2411H1.425C1.16375 15.2411 0.95 15.0125 0.95 14.7331V13.4122C0.95 11.6182 2.31266 10.1607 3.99 10.1607C4.57187 10.1607 5.15078 10.6688 6.65 10.6688C8.14625 10.6688 8.72813 10.1607 9.31 10.1607C10.9873 10.1607 12.35 11.6182 12.35 13.4122V14.7331ZM6.65 8.1286C8.74891 8.1286 10.45 6.30919 10.45 4.0643C10.45 1.81941 8.74891 0 6.65 0C4.55109 0 2.85 1.81941 2.85 4.0643C2.85 6.30919 4.55109 8.1286 6.65 8.1286ZM6.65 1.01607C8.22047 1.01607 9.5 2.3846 9.5 4.0643C9.5 5.744 8.22047 7.11252 6.65 7.11252C5.07953 7.11252 3.8 5.744 3.8 4.0643C3.8 2.3846 5.07953 1.01607 6.65 1.01607Z"
        fill="#062241"
        fillOpacity="0.8"
      />
    </svg>
  );
};

export default AddUser;
